// 企业管理
const CompanyIndex = () => import('@/views/company/index/index.vue') // 园区企业
const CompanyReviewList = () => import('@/views/company/reviewList/index.vue') // 入驻申请

export default {
  CompanyIndex,
  CompanyReviewList
}


